const cartPk = {
	title: 'میری شاپنگ بیگ',
	clearAll: 'سب صاف کریں',
	itemsInBag: (n) => `${n} آئٹمز آپ کے بیگ میں ہیں`,
	sectionCartItems: 'بیگ میں رکھی گئی اشیاء',
	continueShopping: 'خریداری جاری رکھیں',
	orderSummary: 'آرڈر خلاصہ',
	subtotal: 'ذیلی مجموعہ',
	delivery: 'ڈلیوری چارج',
	free: 'فری',
	discount: 'رعایت',
	total: 'کل',
	couponPlaceholder: 'کوپن کوڈ درج کریں',
	applyCoupon: 'کوپن لگائیں',
	proceedCheckout: 'چیک آؤٹ پر جائیں',
	trust: {
		securePayment: '100% محفوظ ادائیگی',
		fastDelivery: 'تیز ترسیل',
		cod: 'کیش آن ڈلیوری'
	},
	units: {
		items: 'آئٹمز'
	},
	labels: {
		store: 'دکان',
		storeName: 'دکان کا نام'
	},
	empty: {
		title: 'آپ کی کارٹ خالی ہے',
		subtitle: 'لگتا ہے کہ آپ نے ابھی تک کوئی شے شامل نہیں کی۔\nہماری زبردست اشیاء دیکھیں اور خریداری شروع کریں!',
		cta: 'خریداری شروع کریں'
	},
	item: {
		inStock: 'اسٹاک میں موجود',
		removed: 'شے کارٹ سے ہٹا دی گئی'
	},
	cleared: 'تمام اشیاء کارٹ سے ہٹا دی گئیں'
};

export default cartPk;


